import PropTypes from 'prop-types';
import { EventFinderForm } from './EventFinderForm';
import { EventFinderFooter } from './EventFinderFooter';

import './EventFinder.scss';

export const EventFinder = (props) => {
  const { eventFinderFormData, popularSearches } = props;

  return (
    <div className="event-finder__container container" data-testid="event-finder">
      <h2 className="event-finder__heading text-center">Find what's on at Arts Centre Melbourne</h2>
      <EventFinderForm
        eventFinderFormData={eventFinderFormData}
        genreDefaultValue="All events"
        timeDefaultValue="At any time"
      />
      <div className="row">
        <EventFinderFooter popularSearches={popularSearches} />
      </div>
    </div>
  );
};

export const EventFinderSC = (props) => {
  const { sitecoreData } = props;
  return <EventFinder {...sitecoreData} />;
};

EventFinder.propTypes = {
  eventFinderFormData: PropTypes.object.isRequired,
  popularSearches: PropTypes.array,
};

EventFinderSC.propTypes = {
  sitecoreData: PropTypes.object,
};
